import { Flex } from '@iheartjane/reefer';
import differenceBy from 'lodash-es/differenceBy';

import type { Store } from '@jane/shared/types';

import type { InternalFeeling } from '../../../data-access';
import { FeelingTile } from '../FeelingTile/FeelingTile';
import { ProductDetailsSection } from '../ProductDetailsSection/ProductDetailsSection';

export type FeelingSectionProps = {
  disabledFeelings: Store['disabled_feeling_and_activity_tags'];
  feelings: InternalFeeling[];
  isLoading: boolean;
};

export const FeelingSection = ({
  disabledFeelings,
  isLoading,
  feelings,
}: FeelingSectionProps) => {
  const validFeelings = differenceBy(feelings, disabledFeelings, (value) =>
    typeof value === 'string'
      ? value.toLowerCase()
      : value.feeling.toLowerCase()
  );

  return validFeelings.length > 0 ? (
    <ProductDetailsSection
      ariaLabel="product feelings section"
      title="Top customer feelings"
      isLoading={isLoading}
    >
      <Flex justifyContent="center" flexDirection="row">
        {validFeelings.slice(0, 3).map(({ feeling }, index) => (
          <FeelingTile
            key={feeling}
            feeling={feeling}
            ml={index > 0 ? 16 : 0}
          />
        ))}
      </Flex>
    </ProductDetailsSection>
  ) : null;
};
